import { useEffect, useState } from "react";
import { api, fileUrl } from "./api";

/**
 * Module-level cache so all consumers share the same site-settings fetch.
 * The first hook caller triggers the load; subsequent callers reuse it.
 */
let _cache = null;
let _waiters = [];
let _loading = false;

function loadOnce() {
  if (_cache) return Promise.resolve(_cache);
  if (!_loading) {
    _loading = true;
    api
      .get("/site-settings")
      .then((r) => {
        _cache = r.data || {};
      })
      .catch(() => {
        _cache = {};
      })
      .finally(() => {
        _loading = false;
        const queued = _waiters;
        _waiters = [];
        queued.forEach((cb) => cb(_cache));
      });
  }
  return new Promise((resolve) => {
    _waiters.push(resolve);
  });
}

export default function useSiteSettings() {
  const [s, setS] = useState(_cache);
  useEffect(() => {
    let mounted = true;
    loadOnce().then((data) => {
      if (mounted) setS(data);
    });
    return () => {
      mounted = false;
    };
  }, []); // mount-only fetch; loadOnce is module-stable

  return s || {};
}

export function profilePdfUrl(settings) {
  const u = settings?.company_profile_pdf_url;
  return u ? fileUrl(u) : null;
}

export function refreshSiteSettings() {
  _cache = null;
  return loadOnce();
}
